export const ActionTypes = {
  LOADING: "CREATE_MASTER_PLAN_LOADING",
  ERROR: "CREATE_MASTER_PLAN_ERROR",
  SUCCESS: "CREATE_MASTER_PLAN_SUCCESS",
};
